import React from 'react';

/**
 * The studio's branding at the top of a shared page.
 *
 * With a banner image it's a full-width band with the logo + name overlaid;
 * with no banner it collapses to a clean branding strip. Renders nothing when
 * the studio has neither a logo nor a name, so the page simply opens on its
 * hero as it did before branding existed.
 *
 * Shared by the shared gallery, person and selection pages so a studio's
 * branding reads identically wherever the client lands.
 */
function StudioBrandBar({ studioName, logoUrl, bannerUrl }) {
  if (!logoUrl && !studioName) return null;
  return (
    <header className={`pg-brandbar ${bannerUrl ? 'pg-brandbar--banner' : ''}`}>
      {bannerUrl && (
        <>
          <img className="pg-brandbar-bg" src={bannerUrl} alt="" />
          <div className="pg-brandbar-scrim" />
        </>
      )}
      <div className="pg-brandbar-credit">
        {logoUrl && <img src={logoUrl} alt="" className="pg-brandbar-logo" />}
        {studioName && <span className="pg-brandbar-name">{studioName}</span>}
      </div>
    </header>
  );
}

export default StudioBrandBar;
